import React, { useEffect, Fragment } from "react";
import Loader from "../../../../components/styled-components/loader/loader";
import { MODULE_API } from "../../../../apis";
import { useState } from "react";
import DropDown from "../../../../components/styled-components/dropdown/dropdown";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import {
  Radio,
  DatePicker,
  Button,
  Collapse,
  Select,
  Switch,
  InputNumber,
  AutoComplete,
  Input,
} from "antd";
import * as Styles from "./styles/allocationSubFormStyles";
import moment from "moment";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import CurrencyCosts from "../../../../components/form/CurrencyForAssets";
import { ToolTipCreator } from "../../../../helpers/ToolTipCreator";
import FETCH from "../../../../utils/fetch";
import { AddOwnerModal } from "../../../../newComponents/ManageOwners/component/AddOwnerModal";
const { Option } = Select;
const Options = AutoComplete.Option;

const IncomeSubForm = () => {
  let tabs2;
  const AllTabs = {
    "INCOME DETAILS": {
      name: "INCOME DETAILS",
      enabled: false,
      priority: 1,
    },
    "ADDITIONAL DETAILS": {
      name: "ADDITIONAL DETAILS",
      enabled: false,
      priority: 2,
    },
    TAXATION: {
      name: "TAXATION",
      enabled: false,
      priority: 3,
    },
  };

  const history = useHistory();
  const location = useLocation();
  const { module } = useParams();
  const { id } = useParams();
  const { view } = useParams();
  console.log("module", module, id);
  // --------------------states---------------
  const [moduleName, setModuleName] = useState(null);
  const [moduleId, setModuleId] = useState(null);

  const [loading, setIsLoading] = useState(false);
  const [fields, setFields] = useState({});
  const [tabs, setTabs] = useState([]);
  const [tabsControl, setTabsControl] = useState({});
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [activeTabName, setActiveTabName] = useState("INCOME DETAILS");
  const [activeStep1, setActiveStep1] = useState(0);

  // const [totalTabs, setTotalTabs] = useState(0);
  const [submitBody, setSubmitBody] = useState({});
  const [fieldsData, setFieldsData] = useState({});

  //   ---------------functions----------------------
  const getAssetFields = async (assetName) => {
    setIsLoading(true);
    console.log("assetName....", assetName);
    const res = await MODULE_API.assetFiledDetails(assetName);
    setIsLoading(false);
    // console.log("result....", res);
    if (res) {
      res.attributes &&
        res.attributes.map((attribute) => {
          setFields((prevValue) => {
            return {
              ...prevValue,
              [attribute["groupName"]]: {
                ...(prevValue[attribute["groupName"]] || {}),
                [attribute["id"]]: attribute,
              },
            };
          });
        });
    }
  };
  const getAssetFieldsData = async (id) => {
    setIsLoading(true);
    console.log("asset id....", id);
    const res = await MODULE_API.fetchDetails(id);
    if (res && res.data) {
      setFieldsData(res.data);
      console.log("result....", res);
    }
    setIsLoading(false);
  };
  function handlePreviousFormButton() {
    if (
      activeTabName == "INCOME DETAILS" &&
      location.state &&
      location.state.from &&
      location.state.from === "/protector/disability"
    ) {
      history.goBack(); // Navigate back
    }
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a - 1];
    setActiveTabName(tabsControl[b]);
    setActiveStep1(a - 1);
  }
  function tabsPrevNextControl() {
    let temp = Object.keys(AllTabs);
    tabs2 = tabs.map((tab) => tab.toUpperCase());
    let obj = {};
    tabs2.map((name) => {
      if (temp.includes(name)) {
        obj = {
          ...obj,
          [AllTabs[name].priority]: AllTabs[name].name,
        };
      }
    });
    return obj;
  }
  useEffect(() => {
    setTabsControl(tabsPrevNextControl());
  }, [tabs]);
  function handleNextFormButton() {
    let temp = Object.values(tabsControl);
    let a = temp.indexOf(activeTabName);
    let b = Object.keys(tabsControl)[a + 1];
    setActiveTabName(tabsControl[b]);
    setActiveStep1(b - 1);
  }

  async function handleSubmit() {
    console.log("moduleName", submitBody);
    if (moduleName && moduleId === null) {
      console.log("create api");
      try {
        setIsLoading(true);
        if (moduleName && moduleId === null)
          await MODULE_API.addAsset(moduleName, {
            clientModules: [
              {
                ...submitBody,
                ["Net Amount"]: submitBody["Net Amount"]
                  ? submitBody["Net Amount"]
                  : 0,
              },
            ],
          });
        setIsLoading(false);
        // history.push("/income");
      } catch (error) {
        setIsLoading(false);
        swal({
          title: "Error",
          text: "Error while Saving Module",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
    }
    if (moduleId && moduleName && !view) {
      console.log("updateApi");
      try {
        setIsLoading(true);
        await MODULE_API.updateClientModule(moduleId, {
          ...submitBody,
        });
        setIsLoading(false);
        // history.push("/income");
      } catch (error) {
        setIsLoading(false);
        swal({
          title: "Error",
          text: "Error while Saving Module",
          icon: "error",
          buttons: true,
          dangerMode: true,
        });
      }
    }
    if (
      location.state &&
      location.state.from &&
      location.state.from === "/protector/disability"
    ) {
      history.goBack(); // Navigate back
    } else {
      history.push("/income");
    }
  }

  function currentTab(tab) {
    tabs2 = tabs.map((tab) => tab.toUpperCase());
    console.log("currentTab", tab, tabs2.includes(tab));
    console.log("tabs2", tabs2, "\n", "currentTab", `'${tab}'`);

    let cond = tabs2.includes(tab);
    if (cond) {
      let ind = tabs2.indexOf(tab);
      console.log("tabs.indexOf(tab)", tabs2.indexOf(tab));
      setActiveTabIndex(ind);
      setActiveTabName(tab);
    }
  }

  useEffect(() => {
    setTabs(Object.keys(fields));
  }, [fields]);
  useEffect(() => {
    currentTab("INCOME DETAILS");
  }, [tabs]);
  useEffect(() => {
    let tabs2 = tabs.map((item) => item.toUpperCase());
    let temp = tabs2.indexOf(activeTabName);
    if (temp !== -1) {
      setActiveTabIndex(temp);
    }
  }, [activeTabName]);

  //   --------------LOG useEffects-------------------
  useEffect(() => {
    console.log("fields", fields);
  }, [fields]);
  useEffect(() => {
    if (module) {
      getAssetFields(module);
      setModuleName(module || null);
    }
    if (id) {
      getAssetFieldsData(id);
      setModuleId(id || null);
    }
  }, [module, id]);

  const isDateFilled =
  (submitBody &&
    submitBody["Date Income Starts"] &&
    submitBody["Date Income Ends"]) ||
  (fieldsData &&
    fieldsData["Date Income Starts"] &&
    fieldsData["Date Income Ends"]);

  return (
    <>
      {/* <AssetLissting/> */}
      <hr />
      <TabNavigationComponent
        tabs={tabs}
        activeTabIndex={activeTabIndex}
        setActiveTabIndex={setActiveTabIndex}
        activeTabName={activeTabName}
        setActiveTabName={setActiveTabName}
        activeStep1={activeStep1}
        currentTab={currentTab}
        AllTabs={AllTabs}
      />
      <hr />
      <form>
        {tabs.length > 0 && (
          <FormCreator
            data={fields[tabs[activeTabIndex]]}
            values={fieldsData}
            title={tabs[activeTabIndex]}
            setSubmitBody={setSubmitBody}
            activeTabName={activeTabName}
          />
        )}
      </form>
      {console.log("tabs.length>>", tabs.length)}
      {tabs.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "3rem 3rem",
            width: "96%",
          }}
        >
          <Button
            onClick={() => {
              if (activeTabName == "INCOME DETAILS") {
                history.goBack();
              } else {
                handlePreviousFormButton();
              }
            }}
            style={{
              backgroundColor: "transparent",
              color: "#2a3da3",
              borderRadius: "8px",
              border: "1px solid #2a3da3",
              width: "250px",
              height: "3rem",
              fontSize: "16px",
              fontWeight: "500",
              fontFamily: "Poppins",
            }}
            // disabled={activeTabName == "INCOME DETAILS" && ((location.state && location.state.from && location.state.from !== "/protector/disability") || !location.state)}
          >
            Previous
          </Button>
          {/*

          {activeTabName === "INCOME INFORMATION" && "submit end"}
          {(activeTabName === "FINANCIAL INFORMATION" && tabs.length === 2) && "here we need submit 2" }
          {(activeTabName === "PRODUCT INFORMATION" && tabs.length === 1) && "here we need submit 1"}
          */}
          {activeTabName === "TAXATION" ||
          (activeTabName === "INCOME DETAILS" && tabs.length === 1) ||
          (activeTabName === "ADDITIONAL DETAILS" && tabs.length === 2) ? (
            <Button
              onClick={() => {
                handleSubmit();
              }}
              disabled={
                (fieldsData &&
                  fieldsData.hasOwnProperty("Passive or Active")) ||
                (submitBody && submitBody.hasOwnProperty("Passive or Active"))
                  ? false
                  : true
              }
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                fontFamily: "Poppins",
                width: "250px",
                height: "3rem",
                fontSize: "16px",
                fontWeight: "500",
                opacity:
                  (fieldsData &&
                    fieldsData.hasOwnProperty("Passive or Active")) ||
                  (submitBody && submitBody.hasOwnProperty("Passive or Active"))
                    ? 1
                    : 0.5,
              }}
            >
              Submit
            </Button>
          ) : (
            <Button
              onClick={handleNextFormButton}
              style={{
                backgroundColor: "#2a3da3",
                color: "white",
                borderRadius: "8px",
                fontFamily: "Poppins",
                width: "250px",
                height: "3rem",
                fontSize: "16px",
                fontWeight: "500",
                opacity: isDateFilled ? 1 : 0.5,
              }}
              disabled={!isDateFilled}
            >
              Next
            </Button>
          )}
        </div>
      )}

      <Loader isLoading={loading} />
    </>
  );
};

const FormCreator = ({ data, title, setSubmitBody, activeTabName, values }) => {
  const { Panel } = Collapse;
  // ------------------HOOKS--------------
  const [inputFields, setInputFields] = useState([]);
  const [groupedFields, setGroupedFields] = useState({});
  const [payload, setPayload] = useState({});
  const [attributeValues, setAttributeValues] = useState({});
  const [ownerList, setOwnerList] = useState([]);
  const [formDataOwner, setFormDataOwner] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  console.log("data......", values);
  const handleChangeOwner = (name, value) => {
    setFormDataOwner({
      ...formDataOwner,
      [name]: value,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormDataOwner(null);
  };

  const handleSave = async () => {
    setIsModalOpen(false);
    try {
      let payload = {
        ...formDataOwner,
      };

      setLoading(true);
      let data = await MODULE_API.addAsset("Owners and Entities", {
        clientModules: [{ ...payload }],
      });
      if (data && data.statusCode === 201) {
        swal("Success", "Owner Details Added Successfully.", "success");
        await getOwnersDetails(1);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setFormDataOwner(null);
  };
  const getOwnersDetails = async (page) => {
    try {
      // setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Owners and Entities&page=${page}&limit=30&clientId=${ID}`
            : `?module=Owners and Entities&page=${page}&limit=30`,
        body: {},
      });
      if (datares && datares.records) {
        setOwnerList(datares.records);
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };

  useEffect(() => {
    getOwnersDetails(1);
  }, []);

  useEffect(() => {
    setInputFields(Object.keys(data));
  }, [data]);
  useEffect(() => {
    setSubmitBody(payload);
  }, [payload]);
  useEffect(() => {
    setAttributeValues(values);
  }, [values]);

  const [groupFieldsNew, setGroupFieldsNew] = useState({});
  const [groupFieldsNew2, setGroupFieldsNew2] = useState({});

  useEffect(() => {
    inputFields.map((item) => {
      if (data[item] && data[item]["formGroupName"]) {
        setGroupedFields((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      }
    });
    inputFields.map((item) => {
      if (
        (data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "W2 Income Section") ||
        (data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Advanced Details")
      ) {
        setGroupFieldsNew((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      } else if (
        (data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] === "Advanced Details") ||
        (data[item] &&
          data[item]["formGroupName"] &&
          data[item]["formGroupName"] ===
            "Independent Contractor Income Section")
      ) {
        setGroupFieldsNew2((prevValue) => {
          return {
            ...prevValue,
            [data[item].formGroupName]: {
              ...prevValue[data[item].formGroupName],
              [data[item].id]: data[item],
            },
          };
        });
      } else {
        return null;
      }
    });
  }, [data, inputFields]);

  const [showTempState, setShowTempState] = useState(false);
  const [showFields, setShowFields] = useState(null);
  const customOrderDropDown = [
    "Weekly",
    "Bi-Weekly",
    "Monthly",
    "Bi-Monthly",
    "Quarterly",
    "Semi-Annually",
    "Annually",
    "One-Time",
  ];
  function handleInputFields(inputName, value) {
    setPayload((prevValue) => {
      if (value === "Employee (W-2)") {
        setShowFields(value);
        console.log("this is the V2 income details");
        setShowTempState(true);
      } else {
        // setShowFields(value);
        console.log("this is the unable to chatch the input V2 income details");
        // setShowTempState(false);
      }

      return { ...prevValue, [inputName]: value };
    });
  }
  const handleToogle = (name, checked) => {
    const currentDate = new Date();
    if (name === "Date Income Starts") {
      setPayload((prevValue) => {
        return {
          ...prevValue,
          [name]: currentDate,
          ["Already Earning Income"]: checked,
        };
      });
      if (attributeValues && attributeValues) {
        setAttributeValues((prevValue) => {
          return {
            ...prevValue,
            [name]: currentDate,
            ["Already Earning Income"]: checked,
          };
        });
      }
    } else {
      const dateValue = checked
        ? new Date(currentDate.setFullYear(currentDate.getFullYear() + 100))
        : currentDate;
      setPayload((prevValue) => {
        return {
          ...prevValue,
          [name]: dateValue,
          ["No End Date"]: checked,
        };
      });
      if (attributeValues && attributeValues) {
        setAttributeValues((prevValue) => {
          return {
            ...prevValue,
            [name]: dateValue,
            ["No End Date"]: checked,
          };
        });
      }
    }
  };

  const DynamicComponentGenerator = (item) => {
    {
      if (data[item]) {
        if (data[item]["formGroupName"]) {
          return <></>;
        } else {
          return SubFieldGenerator(data[item]);
        }
      }
    }
  };
  const SubFieldGenerator = (item) => {
    const { view } = useParams();

    switch (item.dataType) {
      case "boolean":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              {console.log(
                "values[item.name]",
                values[item.name],
                attributeValues[item.name]
              )}

              <label style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {item.name}
                  {item &&
                    item.name &&
                    item.name === "Adjusted Gross Income (AGI)" && (
                      <ToolTipCreator
                        name={
                          item.name === "Adjusted Gross Income (AGI)"
                            ? "Income_Adjusted_Gross_Income"
                            : ""
                        }
                      />
                    )}
                </div>
                <Radio.Group
                  disabled={view}
                  style={{ marginTop: "0.5rem" }}
                  value={
                    values[item.name]
                      ? ((values[item.name] === true ||
                          values[item.name] === "true") &&
                          "true") ||
                        ((values[item.name] === false ||
                          values[item.name] === "false") &&
                          "false")
                      : ((values[item.name] === true ||
                          values[item.name] === "true") &&
                          "true") ||
                        ((values[item.name] === false ||
                          values[item.name] === "false") &&
                          "false")
                  }
                  // defaultValue={payload[item.name] ? payload[item.name] : attributeValues[item.name] ? attributeValues[item.name] : ""}
                  size="large"
                  onChange={(e) => {
                    handleInputFields(item.name, e.target.value);
                    console.log("radio value", e.target.value);
                    values[item.name] = e.target.value;
                  }}
                >
                  <Radio.Button value="true">Yes</Radio.Button>
                  <Radio.Button value="false">No</Radio.Button>
                </Radio.Group>
              </label>
            </Styles.SubFormDiv>
          </>
        );

        break;
      case "string":
        return (
          <>
            {item.name === "Name" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label
                  style={
                    {
                      // marginTop: "20px",
                    }
                  }
                >
                  {item.name}
                </label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    type="text"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                      // marginTop:"0.5rem"
                    }}
                    onChange={(e) => {
                      handleInputFields(item.name, [e.target.value]);
                    }}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label
                  style={
                    {
                      // marginTop: "20px",
                    }
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                  >
                    {item.name}
                    {["Income Name", "Owner"].includes(item.name) && (
                      <ToolTipCreator
                        name={
                          item.name === "Income Name"
                            ? "Income_Name"
                            : "Income_Owner"
                        }
                      />
                    )}
                  </div>
                </label>
                {item.name === "Owner" ? (
                  <div style={{ width: "94%" }}>
                    <AutoComplete
                      className="custom-auto-select"
                      placeholder="Select Owner"
                      value={
                        payload && payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                      // When user types
                      onSearch={(text) => {
                        handleInputFields(item.name, text);
                      }}
                      // When user selects an option
                      onSelect={(value, option) => {
                        if (value === "__add_new_owner__") {
                          setIsModalOpen(true);
                        } else {
                          handleInputFields(item.name, value);
                        }
                      }}
                      optionLabelProp="value"
                      dataSource={[
                        ...ownerList.map((owner, idx) => (
                          <Options key={idx} value={owner.Name}>
                            {owner.Name} {owner.Type ? `(${owner.Type})` : ""}
                          </Options>
                        )),
                        <Options value="__add_new_owner__" key="add_new_owner">
                          + Add New Owner
                        </Options>,
                      ]}
                    >
                      <Input className="custom-auto-select-input" />
                    </AutoComplete>
                    {isModalOpen && (
                      <AddOwnerModal
                        title={"Add Owner Details"}
                        open={isModalOpen}
                        handleChange={handleChangeOwner}
                        handleCancel={handleCancel}
                        data={formDataOwner && formDataOwner}
                        handleSave={handleSave}
                      />
                    )}
                  </div>
                ) : (
                  <Styles.InputBorder>
                    <input
                      readOnly={view}
                      type="text"
                      style={{
                        outline: "none",
                        border: "none",
                        width: "98%",
                        // marginTop:"0.5rem"
                      }}
                      onChange={(e) => {
                        handleInputFields(item.name, e.target.value);
                      }}
                      value={
                        payload[item.name]
                          ? payload[item.name]
                          : attributeValues[item.name]
                          ? attributeValues[item.name]
                          : ""
                      }
                    />
                  </Styles.InputBorder>
                )}
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;
      case "int":
        return (
          <>
            {item.name === "Percent" ||
            item.name === "Account Number" ||
            item.name === "Percent To Survivor" ||
            item.name === "% Yearly Increase" ? (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>{item.name}</label>
                <Styles.InputBorder>
                  <input
                    readOnly={view}
                    // type="number"
                    // pattern="[0-9]*"
                    pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                    style={{
                      outline: "none",
                      border: "none",
                      width: "98%",
                    }}
                    onChange={(e) => {
                      const result = e.target.value.replace(/\D/g, "");
                      handleInputFields(item.name, result);
                      if (attributeValues && attributeValues[item.name]) {
                        attributeValues[item.name] = result;
                      }
                    }}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                  />
                  {(item.name === "Percent To Survivor" ||
                    item.name === "% Yearly Increase") && (
                    <span
                      style={{
                        fontSize: "20px",
                        padding: "8px",
                        display: "flex",
                        alignItems: "center",
                        color: "rgba(0, 0, 0, 0.65)",
                        background: "#fafafa",
                        borderTopRightRadius: "8px",
                        borderBottomRightRadius: "8px",
                        borderLeft: "1px solid #d9d9d9",
                      }}
                    >
                      %
                    </span>
                  )}
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            ) : (
              <Styles.SubFormDiv
                style={{
                  marginTop: "0.5rem",
                }}
              >
                <label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      columnGap: "3px",
                    }}
                  >
                    {item.name}
                    {item &&
                      item.name &&
                      [
                        "Gross Monthly Wages",
                        "Amount Subject to Federal Taxation",
                        "Net Amount",
                      ].includes(item.name) && (
                        <ToolTipCreator
                          name={
                            item.name === "Gross Monthly Wages"
                              ? "Income_Gross_Monthly"
                              : item.name ===
                                "Amount Subject to Federal Taxation"
                              ? "Income_Amount_Subject_to_Fed_Taxation"
                              : "Income_Net_Amount"
                          }
                        />
                      )}
                  </div>
                </label>
                <Styles.InputBorder
                  style={{
                    paddingLeft:
                      item.name !== "Percent" || item.name === "Account"
                        ? "0"
                        : "1rem",
                  }}
                >
                  <span className="dollarSymbol">$</span>
                  <InputNumber
                    disabled={view}
                    style={{
                      outline: "none",
                      border: "none",
                      width: "92%",
                      height: "3.5rem",
                    }}
                    className="Input"
                    step={0.01}
                    formatter={(value) =>
                      value
                        ? ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : ""
                    }
                    precision={2}
                    parser={(value) => value.replace(/[^0-9.]/g, "")} // Parse valid numbers only
                    name={item.name}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                    onChange={(value) => {
                      handleInputFields(item.name, value);
                    }}
                  />
                  {/* <CurrencyCosts
                    readOnly={view}
                    value={
                      payload[item.name]
                        ? payload[item.name]
                        : attributeValues[item.name]
                        ? attributeValues[item.name]
                        : ""
                    }
                    onChange={(e) => {
                      const result = e.target.value.replace(/\D/g, "");
                      handleInputFields(item.name, result);
                    }}
                  /> */}
                </Styles.InputBorder>
              </Styles.SubFormDiv>
            )}
          </>
        );

        break;
      case "dropdown":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              <label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {item.name}{" "}
                  {item.name === "Passive or Active" && (
                    <span style={{ color: "red", fontSize: "20px" }}>*</span>
                  )}
                  {item.name &&
                    [
                      "Frequency of Pay Periods",
                      "Federal Taxation Type",
                      "State Taxation Type",
                      "Passive or Active",
                    ].includes(item.name) && (
                      <ToolTipCreator
                        name={
                          item.name === "Frequency of Pay Periods"
                            ? "Income_Frequency_of_Pay_Periods"
                            : item.name === "Federal Taxation Type"
                            ? "Income_Federal_Taxation_Type"
                            : item.name === "State Taxation Type"
                            ? "Income_State_Taxation_Type"
                            : "Income_Passive_or_Active"
                        }
                      />
                    )}
                </div>
              </label>
              <div style={{ width: "94%" }}>
                <DropDown
                  readOnly={view}
                  style={defaultStyles.styles.dropDown.m_smallDropdown1}
                  listingStyle={{
                    ...defaultStyles.styles.dropDown.m_smallDropdown2,
                    height: "auto",
                  }}
                  name={item.name}
                  title={item.name}
                  list={
                    item.name === "Frequency of Pay Periods"
                      ? [...item.attribute_default_values].sort((a, b) => {
                          return (
                            customOrderDropDown.indexOf(a.value) -
                            customOrderDropDown.indexOf(b.value)
                          );
                        })
                      : item.attribute_default_values
                  }
                  displayKey="value"
                  disableSearch={false}
                  setSelectedItem={({ name, value }) => {
                    handleInputFields(name, value);
                  }}
                  defaultValue={
                    payload && payload[item.name]
                      ? payload[item.name]
                      : attributeValues[item.name]
                      ? attributeValues[item.name]
                      : ""
                  }
                  // defaultValue={
                  //   values && values[item.name]
                  //     ? values[item.name]
                  //     : attributeValues[item.name]
                  //     ? attributeValues[item.name]
                  //     : ""
                  // }
                />
              </div>
            </Styles.SubFormDiv>
          </>
        );

        break;
      case "date":
        return (
          <>
            <Styles.SubFormDiv
              style={{
                marginTop: "0.5rem",
              }}
            >
              {console.log(
                "Dateeeeee",
                payload[item.name]
                  ? moment(payload[item.name])
                  : moment(attributeValues[item.name] || new Date())
              )}
              <label
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "90%",
                }}
              >
                {/* {item.name} */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    columnGap: "3px",
                  }}
                >
                  {item.name}
                  {["Date Income Starts", "Date Income Ends"].includes(
                    item.name
                  ) && (
                    <span style={{ color: "red", fontSize: "20px" }}>*</span>
                  )}
                  {["Date Income Starts", "Date Income Ends"].includes(
                    item.name
                  ) && (
                    <ToolTipCreator
                      name={
                        item.name === "Date Income Starts"
                          ? "Income_Date_Income_Starts"
                          : "Income_Date_Income_Ends"
                      }
                    />
                  )}
                </div>
                {["Date Income Starts", "Date Income Ends"].includes(
                  item.name
                ) && (
                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        columnGap: "3px",
                      }}
                    >
                      {item.name === "Date Income Starts"
                        ? "Already Earning Income"
                        : "No End Date"}
                      {["Date Income Ends"].includes(item.name) && (
                        <ToolTipCreator
                          name={
                            item.name === "Date Income Ends"
                              ? "Income_No_End_Date"
                              : ""
                          }
                        />
                      )}
                    </div>
                    <Switch
                      name={item.name}
                      checked={
                        item.name === "Date Income Starts"
                          ? !!(
                              payload["Already Earning Income"] ||
                              attributeValues["Already Earning Income"]
                            )
                          : !!(
                              payload["No End Date"] ||
                              attributeValues["No End Date"]
                            )
                      }
                      onChange={(checked) => handleToogle(item.name, checked)}
                    />
                  </div>
                )}
              </label>
              <Styles.InputBorder
                style={{
                  display:
                    (item.name === "Date Income Starts" &&
                      ((payload && payload["Already Earning Income"]) ||
                        (attributeValues &&
                          attributeValues["Already Earning Income"]))) ||
                    (item.name === "Date Income Ends" &&
                      ((payload && payload["No End Date"]) ||
                        (attributeValues && attributeValues["No End Date"])))
                      ? "none"
                      : "flex",
                  alignItems: "center",
                  overflow: "hidden",
                }}
              >
                <DatePicker
                  disabled={view}
                  // className="ant-calendar-picker-input ant-input"
                  format={"MM/DD/YYYY"}
                  style={{
                    outline: "none",
                    border: "none",
                    borderRadius: "0.5rem",
                  }}
                  placeholder="Select Purchase Date"
                  onChange={(e) => {
                    if (e !== null) {
                      handleInputFields(item.name, e.toString());
                      values[item.name] = e.toString();
                    }
                  }}
                  value={
                    values[item.name]
                      ? moment(values[item.name])
                      : moment(attributeValues[item.name] || new Date())
                  }
                />
              </Styles.InputBorder>
            </Styles.SubFormDiv>
          </>
        );

        break;

      default:
        console.error("invalid DataType Detected :::: ", item.dataType);
        // return <h1>invalid DataType Detected :::: {item.dataTyp  e}</h1>;
        break;
    }
  };

  const { module } = useParams();

  // const thisContributionArray = [
  //   "Bonus from Work",
  //   "Distribution from Asset",
  //   "Insurance Payout",
  //   "Settlement (Structured or Lump)",
  //   "Annuity Non-Investment Income",
  //   "Personal Loans",
  //   "Reverse Motgage",
  //   "Royalties",
  //   "Social Security",
  //   "Bonus from Work",
  //   "Business Proceeds - Ordinary",
  //   "Earned Income From Work",
  //   "Military Benefits",
  //   "Pension",
  //   "Sales Commision from Work",
  //   "Unemployment",
  //   "Alimony",
  //   "Dividends - Ordinary",
  //   "Dividends - Qualified",
  //   "Government Agency Bond",
  //   "Government Agency Bond - State Tax Free",
  //   "Interest Income - Ordinary",
  //   "Investment Sale Proceeds - LT Gains",
  //   "Real Estate Rental",
  //   "IRA / Retirement Distributions",
  //   "Muni Bonds - In State",
  //   "Muni Bonds - Out of State",
  //   "Portfolio Income",
  //   "RMD Distributions",
  //   "Other Investment Income",
  // ];

  const groupedFieldsPage = (fieldss) => {
    if (
      ((payload && payload["Type of Employment Income"]) ||
        (attributeValues && attributeValues["Type of Employment Income"])) ===
      "Employee (W-2)"
    ) {
      console.log("here in if elseeeee");
      let temp = Object.values(fieldss)[0];
      console.log("temp", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      return temmp;
    } else {
      console.log("here in elseeeee if ", fieldss);
      let temp = Object.values(fieldss)[0];
      console.log("temp2", temp);
      let temmp = temp && Object.values(temp)[0].groupName.toUpperCase();
      console.log("temmp return", temmp);
      return temmp;
    }
  };
  const { view } = useParams();

  return (
    <>
      <div style={{ margin: " 0 3rem" }}>
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h1
            style={{
              fontFamily: "Poppins",
              fontSize: "20px",
              fontWeight: "500",
              color: "#030229",
            }}
          >
            {title}
          </h1>
          <h1
            style={{
              fontFamily: "Poppins",
              fontSize: "16px",
              fontWeight: "500",
              color: "grey",
            }}
          >
            {view ? "(Read Only)" : ""}
          </h1>
        </div>
      </div>
      <Styles.FormDiv>
        {inputFields.map((item, indx) => {
          {
            /* console.log("item in mappppp", item); */
          }
          return DynamicComponentGenerator(item);
        })}
      </Styles.FormDiv>
      <div>
        {console.log(
          "selected moduley",
          (payload && payload["Type of Employment Income"]) ||
            (attributeValues && attributeValues["Type of Employment Income"]),
          groupFieldsNew2
        )}

        {(() => {
          // determine employment type
          const typeOfEmployment =
            (payload && payload["Type of Employment Income"]) ||
            (attributeValues && attributeValues["Type of Employment Income"]);

          // choose which group object to render
          // const selectedGroup =
          //   activeTabName === "INCOME DETAILS" && groupFieldsNew && groupFieldsNew["Advanced Details"]
          //     ? groupFieldsNew // always show Advanced Details if present
          //     : typeOfEmployment === "Employee (W-2)"
          //     ? groupFieldsNew
          //     : typeOfEmployment === "Independent Contractor (1099)"
          //     ? groupFieldsNew2
          //     : {};
          let selectedGroup = {};

          if (
            activeTabName === "INCOME DETAILS" &&
            groupFieldsNew &&
            groupFieldsNew["Advanced Details"]
          ) {
            // For W-2, remove "Advanced Details" from groupFieldsNew
            if (typeOfEmployment === "Employee (W-2)") {
              const { ["Advanced Details"]: _, ...rest } = groupFieldsNew;
              console.log("resss", rest, groupFieldsNew);
              selectedGroup = rest;
            } else {
              // For others (1099), keep Advanced Details
              selectedGroup = groupFieldsNew;
            }
          } else if (typeOfEmployment === "Employee (W-2)") {
            const { ["Advanced Details"]: _, ...rest } = groupFieldsNew;
            console.log("resss", rest, groupFieldsNew);
            selectedGroup = rest;
          } else if (typeOfEmployment === "Independent Contractor (1099)") {
            selectedGroup = groupFieldsNew2;
          } else {
            selectedGroup = {};
          }

          console.log(
            "selectedGrrr",
            selectedGroup,
            groupedFieldsPage(selectedGroup),
            activeTabName,
            groupedFieldsPage(selectedGroup) != activeTabName
          );
          // if active tab doesn't match, return null / nothing
          if (groupedFieldsPage(selectedGroup) != activeTabName) return null;

          // iterate group keys
          return Object.keys(selectedGroup).map((grpField, index) => {
            const groupedFieldsItemKeys = Object.keys(
              selectedGroup[grpField] || {}
            );

            // Pre-map for side-effects (optional). You had a map that logs/returns -- keep it minimal
            groupedFieldsItemKeys.map((ItemKey) => {
              const field = selectedGroup[grpField][ItemKey];
              if (!field) return null;
              switch (field.subType) {
                case "array":
                  // keep original debug if needed
                  // console.log("type array detected");
                  return null;
                case "single":
                  return null;
                default:
                  return null;
              }
            });

            return (
              <React.Fragment key={grpField + "_" + index}>
                <h1
                  style={{
                    margin: "2rem 3rem",
                    fontFamily: "Poppins",
                    fontSize: "20px",
                    fontWeight: "500",
                    color: "#030229",
                  }}
                >
                  {Object.keys(selectedGroup)[index]}
                </h1>

                <div style={{ margin: "0 3rem", width: "50rem" }}>
                  <Collapse>
                    <Panel
                      header={Object.keys(selectedGroup)[index]}
                      key={"panel_" + index}
                    >
                      {groupedFieldsItemKeys.map((ItemKey) => {
                        const field = selectedGroup[grpField][ItemKey];
                        if (!field) return null;

                        switch (field.subType) {
                          case "array":
                            // debug: console.log("Rendering array subtype:", field.name);
                            return (
                              <React.Fragment key={ItemKey}>
                                {SubFieldGenerator(field)}
                              </React.Fragment>
                            );

                          case "single":
                            return (
                              <React.Fragment key={ItemKey}>
                                {SubFieldGenerator(field)}
                              </React.Fragment>
                            );

                          default:
                            return <h1 key={ItemKey}>default type Detected</h1>;
                        }
                      })}
                    </Panel>
                  </Collapse>
                </div>
              </React.Fragment>
            );
          });
        })()}
      </div>
    </>
  );
};

const TabNavigationComponent = ({
  tabs,
  activeTabIndex,
  currentTab,
  activeTabName,
  setActiveTabName,
  activeStep1,
  AllTabs,
  module,
}) => {
  const [alltabs, setAllTabs] = useState(AllTabs);
  const [tabNames, setTabNames] = useState([]);
  const [activeStep, setActiveStep] = useState(activeStep1);

  useEffect(() => {
    let temp = tabs.map((tab) => tab.toUpperCase());
    setTabNames(temp);
  }, [tabs]);
  useEffect(() => {
    let temp2 = Object.keys(alltabs);
    temp2.map((tab) => {
      if (tabNames.includes(tab)) {
        setAllTabs((prevValue) => ({
          ...prevValue,
          [tab]: { ...prevValue[tab], enabled: true },
        }));
      }
    });
  }, [tabs]);

  useEffect(() => {
    console.log("alltabs", alltabs);
  }, [alltabs]);
  useEffect(() => {
    console.log("tabs", tabs);
    setActiveStep(activeStep1);
  }, [tabs, activeStep1]);
  // console.log("activeTabs", activeTabs);
  return (
    <div>
      <Styles.TabContainer>
        {Object.keys(alltabs).map((tabName, tabIndex) => {
          return (
            <Fragment key={tabIndex}>
              {tabIndex > 0 && (
                <Styles.SpacerLine
                  activeIndex={activeStep}
                  currentIndex={tabIndex}
                ></Styles.SpacerLine>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "70px",
                }}
              >
                <Styles.TabBox
                  onClick={() => {
                    if (alltabs[tabName].enabled) {
                      currentTab(alltabs[tabName].name);
                      setActiveTabName(alltabs[tabName].name);
                      setActiveStep(tabIndex);
                    }
                  }}
                  activeIndex={activeStep}
                  currentIndex={tabIndex}
                  activeStep1={activeStep1}
                  activeTabIndex={activeTabIndex}
                  isActive={alltabs[tabName].name == activeTabName}
                  isEnabled={alltabs[tabName].enabled}
                >
                  {/* {console.log(
                    "  activeTabIndex >= tabIndex && alltabs[tabName].enabled",
                    activeTabIndex,
                    tabIndex,
                    alltabs[tabName].enabled
                  )} */}
                  <Styles.TabBoxNumber>
                    {alltabs[tabName].priority}
                  </Styles.TabBoxNumber>
                </Styles.TabBox>
                <p style={{ margin: "10px 0", textAlign: "center" }}>
                  {alltabs[tabName].name}
                </p>
              </div>
            </Fragment>
          );
        })}
      </Styles.TabContainer>
    </div>
  );
};

export default IncomeSubForm;
